module.exports = __webpack_public_path__ + "static/media/S4N9-1.8dbb0fee.svg";